module.exports = __webpack_public_path__ + "img/default_profile2.5f58f54.jpeg";